'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTileSize, iconTileSizeTag } from '@ni/nimble-components/dist/esm/icons/tile-size';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTileSize };
export { iconTileSizeTag };
export const NimbleIconTileSize = wrap(IconTileSize);